"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.IconWrap = exports.Header = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
}));
const IconWrap = exports.IconWrap = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.primary.main,
  display: 'flex',
  fontSize: '8rem',
  justifyContent: 'center',
  marginTop: theme.spacing(5),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(11)
  }
}));
const Header = exports.Header = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  margin: theme.spacing(4, 0)
}));
